import { AsyncPipe, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { PromoCmsComponents } from '@core/const';
import { CmsConfig, provideDefaultConfig } from '@spartacus/core';
import { PageComponentModule } from '@spartacus/storefront';
import { SdRandomBannerComponent } from './random-banner.component';

@NgModule({
  imports: [NgIf, AsyncPipe, PageComponentModule],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        [PromoCmsComponents.RandomBannerComponent]: {
          component: SdRandomBannerComponent,
        },
      },
    }),
  ],
  declarations: [SdRandomBannerComponent],
})
export class SdRandomBannerModule {}
